import React, {useEffect, useState, useRef, useContext, useCallback } from "react";
import {Navigate } from 'react-router-dom'
import { Grid, ListSubheader, InputAdornment, AccordionSummary, Accordion, AccordionDetails, MenuItem, DialogContent, FormControlLabel, makeStyles, Checkbox, Collapse, Slide , Button, TextField, DialogActions, Tooltip, Card, Dialog, ListItemText, CardHeader, IconButton, ListItemAvatar, Typography, CardContent, Avatar, Snackbar, List, DialogTitle, ListItem, Divider, ListItemIcon, Paper, LinearProgress  } from '@material-ui/core';
import { LoggedContext, HelpActivatedContext, ProactiveContext, overrideContext, RegisteredRefferalsContext, VisitIdContext, uninsuredExeptionChosenContext, UserExamPackagesContext, ExamZeroCaseContext, ZeroCaseNumberContext, ZeroCaseDateContext, ReferralCommentFinalContext, DataContext, UnitContext, RefferalTypesContext, ExamsRegisteredContext, ExamsNonParticipationCasesContext, ExamsAutocompleteContext, DiagnosisAutocompleteContext, PatientInfoContext, InsuranceContext } from '../../Context'
import { ExpandMore, Lock, ArrowBack, Accessibility, Email, Send, Print, HourglassEmpty, History, Cancel, Search, Delete } from '@material-ui/icons';
import { deepPurple, grey } from '@material-ui/core/colors';
import Fuse from 'fuse.js'
import { AvatarGroup, Alert  } from '@material-ui/lab';
import {NavigationButtons, PatientInfo} from '../Prescriptions/Prescriptions'
import Masonry from 'react-masonry-css'
import debounce from "lodash/debounce";
import MaskedInput from 'react-text-mask'
import PropTypes from 'prop-types';
import labTest from '../labTest.svg'
import {FaSyringe, FaNotesMedical} from "react-icons/fa"
import { Provider, ErrorBoundary, useRollbar  } from '@rollbar/react'
import {FallbackUI} from '../FallbackUI'
import {HelperPoper} from '../Prescriptions/Prescriptions'

import { useDemoStore } from '../../Stores/demoStore'
import useStore from '../../Stores/prescriptionStore';
import {DemoMessage, DemoDialog} from'../MainPage/MainPage'

import {PrescriptionDashboard} from'../MainPage/Fab'




const rollbarConfig = {
    accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
    environment: process.env.REACT_APP_ROLLBAR_ENV,
}




export const ReferralPage = () => {
    const [logged, setLogged] = useContext(LoggedContext)  
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
    
    const newVisit = useStore(state => state.newVisit);



    const setDemoDialog = useDemoStore(state => state.setDemoDialog)
      

    useEffect( ()=> {
        if(!newVisit){
            setDemoDialog({ 
                status:true,
                description:<>
                <Typography variant="body1" gutterBottom>
                <strong> Καλώς ήρθατε στη σελίδα καταχώρησης εξετάσεων και παραπεμπτικών!</strong>
                </Typography>
                <br></br>
                <Typography variant="subtitle2" paragraph>
                  Εδώ μπορείτε να καταχωρήσετε εύκολα τις εξετάσεις που χρειάζεστε. Υπάρχουν δύο τρόποι για να το κάνετε:
                </Typography>
                
                <Typography variant="subtitle2" gutterBottom>
                 1. Καταχώρηση μεμονωμένων εξετάσεων:
                </Typography>
                
                <Typography variant="subtitle2" paragraph >
                  Αυτή η επιλογή είναι ιδανική όταν θέλετε να καταχωρήσετε λίγες εξετάσεις. Χρησιμοποιήστε το πεδίο "Εξετάσεις" και αναζητήστε την εξέταση που επιθυμείτε.
                  Η εφαρμογή θα σας προτείνει εξετάσεις που σχετίζονται με τον ασθενή, καθώς και συχνά χρησιμοποιούμενες εξετάσεις.
                </Typography>
                
            
                
                <Typography variant="subtitle2" gutterBottom >
                 2. Υποβοήθηση:
                </Typography>
                
                <Typography variant="subtitle2" gutterBottom>
                  Αυτή η επιλογή είναι πιο χρήσιμη όταν χρειάζεστε να καταχωρήσετε πολλαπλές εξετάσεις ή να παρακολουθήσετε την πορεία της νόσου. Η εφαρμογή θα σας προτείνει:
                </Typography>
                <Typography variant="subtitle2">a. Συχνές εξετάσεις του ασθενούς, για παρακολούθηση της πορείας της νόσου.</Typography>
                <Typography variant="subtitle2" gutterBottom>b .Πακέτα εξετάσεων, για ολοκλήρωση της διάγνωσης και παρακολούθηση νόσου.</Typography>
               
                
                <Typography variant="subtitle2" >
                  Το μόνο που έχετε να κάνετε είναι να επιλέξετε ένα πακέτο εξετάσεων. Η εφαρμογή θα συμπληρώσει αυτόματα τις υπόλοιπες εξετάσεις.
                </Typography>
                
                <br></br>
                
                <Typography variant="subtitle2">
                  Με αυτούς τους δύο τρόπους, η καταχώρηση εξετάσεων γίνεται γρήγορα και εύκολα.
                </Typography>
              </>
            
            })
        }
    },[]) 




    // Reconciled Medical Examination Data
// This file contains consistent medical data with matching IDs across all collections

// =============== EXAMINATIONS ===============
const dummyExams = [
    {
      id: 1,
      description: "Γενική Αίματος",
      examinationGroup: {
        name: "Αιματολογικές Εξετάσεις",
        id: 1
      },
      active: true,
      price: "15.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["αίμα", "γενική", "αιματολογική"]
    },
    {
      id: 2,
      description: "Ακτινογραφία Θώρακος",
      examinationGroup: {
        name: "Ακτινολογικές Εξετάσεις",
        id: 2
      },
      active: true,
      price: "35.00",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["ακτινογραφία", "θώρακας", "πνεύμονες"]
    },
    {
      id: 3,
      description: "Μαγνητική Τομογραφία Εγκεφάλου",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 2
      },
      active: true,
      price: "250.00",
      isHighCost: true,
      isTreatment: false,
      screening: false,
      keyWords: ["μαγνητική", "εγκέφαλος", "κεφάλι"]
    },
    {
      id: 4,
      description: "Τεστ Κοπώσεως",
      examinationGroup: {
        name: "Καρδιολογικές Εξετάσεις",
        id: 3
      },
      active: true,
      price: "80.00",
      isHighCost: false,
      isTreatment: true,
      screening: false,
      keyWords: ["καρδιά", "κόπωση", "καρδιολογικό"]
    },
    {
      id: 5,
      description: "Υπερηχογράφημα Άνω Κοιλίας",
      examinationGroup: {
        name: "Υπερηχογραφήματα",
        id: 4
      },
      active: true,
      price: "70.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["υπέρηχος", "κοιλιά", "ήπαρ"]
    },
    {
      id: 6,
      description: "Τεστ Παπανικολάου",
      examinationGroup: {
        name: "Γυναικολογικές Εξετάσεις",
        id: 5
      },
      active: true,
      price: "40.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["παπ", "γυναικολογικό", "πρόληψη"]
    },
    {
      id: 7,
      description: "Αξονική Τομογραφία Θώρακος",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 2
      },
      active: true,
      price: "180.00",
      isHighCost: true,
      isTreatment: false,
      screening: false,
      keyWords: ["αξονική", "θώρακας", "πνεύμονες"]
    },
    {
      id: 8,
      description: "Σπιρομέτρηση",
      examinationGroup: {
        name: "Πνευμονολογικές Εξετάσεις",
        id: 6
      },
      active: true,
      price: "45.00",
      isHighCost: false,
      isTreatment: true,
      screening: false,
      keyWords: ["πνεύμονες", "αναπνοή", "πνευμονολογικό"]
    },
    {
      id: 9,
      description: "Τριπλέξ Καρωτίδων",
      examinationGroup: {
        name: "Αγγειολογικές Εξετάσεις",
        id: 7
      },
      active: true,
      price: "90.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["αγγεία", "καρωτίδες", "τριπλέξ"]
    },
    {
      id: 10,
      description: "Ηλεκτροεγκεφαλογράφημα",
      examinationGroup: {
        name: "Νευρολογικές Εξετάσεις",
        id: 8
      },
      active: true,
      price: "100.00",
      isHighCost: false,
      isTreatment: true,
      screening: false,
      keyWords: ["εγκέφαλος", "νευρολογικό", "ηλεκτροεγκεφαλογράφημα"]
    },
    // Additional exams with consistent IDs
    {
      id: 590,
      description: "Γλυκοζυλιωμένη Αιμοσφαιρίνη",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "7.00",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["HbA1c", "Γλυκοζυλιωμένη"]
    },
    // Removed duplicate entry with ID 591 (already have ID 1 for "Γενική Αίματος")
    {
      id: 592,
      description: "Κάλιο ορού",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "4.05",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["Κάλιο", "ηλεκτρολύτες"]
    },
    {
      id: 593,
      description: "Γαστροσκόπηση",
      examinationGroup: {
        name: "Ενδοσκοπήσεις",
        id: 9
      },
      active: true,
      price: "85.00",
      isHighCost: false,
      isTreatment: true,
      screening: false,
      keyWords: ["γαστροσκόπηση", "ενδοσκόπηση", "στομάχι"]
    },
    {
      id: 594,
      description: "Λιπιδαιμικός Έλεγχος",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "14.50",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["χοληστερίνη", "τριγλυκερίδια", "HDL", "LDL"]
    },
    {
      id: 595,
      description: "Γενική Ούρων",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "1.76",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["ούρα", "γενική ούρων", "urinalysis"]
    },
    {
      id: 596,
      description: "Ακτινογραφία Θώρακος",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 8
      },
      active: true,
      price: "4.05",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["ακτινογραφία", "θώρακας", "πνεύμονες"]
    },
    {
      id: 597,
      description: "Ηπατικός Έλεγχος",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "20.00",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["SGOT", "SGPT", "γGT", "ALP"]
    },
    {
      id: 598,
      description: "Μαγνητική Τομογραφία ΟΜΣΣ",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 8
      },
      active: true,
      price: "70.00",
      isHighCost: true,
      isTreatment: false,
      screening: true,
      keyWords: ["DEXA", "οστική πυκνότητα", "οστεοπόρωση"]
    },
    {
      id: 599,
      description: "Θυρεοειδικός Έλεγχος",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "30.00",
      isHighCost: false,
      isTreatment: false,
      screening: false,
      keyWords: ["TSH", "T3", "T4", "θυρεοειδής"]
    },
    {
      id: 600,
      description: "Κρεατινίνη ορού",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "4.05",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["κρεατινίνη", "νεφρική λειτουργία"]
    },
    {
      id: 601,
      description: "Ηλεκτρολύτες (K, Na, Ca)",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "12.15",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["κάλιο", "νάτριο", "ασβέστιο", "ηλεκτρολύτες"]
    },
    {
      id: 602,
      description: "Υπερηχογράφημα καρδιάς",
      examinationGroup: {
        name: "Υπερηχογραφήματα",
        id: 8
      },
      active: true,
      price: "70.00",
      isHighCost: true,
      isTreatment: false,
      screening: true,
      keyWords: ["triplex", "καρδιά", "υπερηχογράφημα"]
    },
    {
      id: 603,
      description: "Τεστ Κοπώσεως",
      examinationGroup: {
        name: "Καρδιολογικές Εξετάσεις",
        id: 9
      },
      active: true,
      price: "35.00",
      isHighCost: false,
      isTreatment: true,
      screening: true,
      keyWords: ["κόπωση", "stress test", "καρδιολογική"]
    },
    {
      id: 604,
      description: "Βυθοσκόπηση",
      examinationGroup: {
        name: "Οφθαλμολογικές Εξετάσεις",
        id: 10
      },
      active: true,
      price: "15.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["βυθός", "οφθαλμολογική", "μάτια"]
    },
    {
      id: 605,
      description: "Υπερηχογράφημα νεφρών",
      examinationGroup: {
        name: "Υπερηχογραφήματα",
        id: 8
      },
      active: true,
      price: "45.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["νεφρά", "υπερηχογράφημα", "νεφρική αρτηρία"]
    },
    {
      id: 606,
      description: "Χοληστερόλη πλήρης",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "14.50",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["χοληστερίνη", "HDL", "LDL", "τριγλυκερίδια"]
    },
    {
      id: 607,
      description: "Γενική ούρων 24ώρου",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών 1",
        id: 7
      },
      active: true,
      price: "8.50",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["ούρα", "24ωρο", "μετβολισμός"]
    },
    {
      id: 608,
      description: "Holter Πίεσης 24ώρου",
      examinationGroup: {
        name: "Καρδιολογικές Εξετάσεις",
        id: 9
      },
      active: true,
      price: "55.00",
      isHighCost: false,
      isTreatment: true,
      screening: true,
      keyWords: ["holter", "πίεση", "24ωρο", "καταγραφή"]
    },
    {
      id: 609,
      description: "Doppler καρωτίδων",
      examinationGroup: {
        name: "Υπερηχογραφήματα",
        id: 8
      },
      active: true,
      price: "65.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["doppler", "καρωτίδες", "αγγεία"]
    },
    {
      id: 610,
      description: "Αξονική Τομογραφία Εγκεφάλου",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 8
      },
      active: true,
      price: "150.00",
      isHighCost: true,
      isTreatment: false,
      screening: false,
      keyWords: ["αξονική", "εγκέφαλος", "κεφαλή"]
    },
    {
      id: 611,
      description: "Αξονική Τομογραφία Νεφρών",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 8
      },
      active: true,
      price: "180.00",
      isHighCost: true,
      isTreatment: false,
      screening: false,
      keyWords: ["αξονική", "νεφρά", "πέτρες"]
    },
    // Adding thyroid panel exams
    {
      id: 1001,
      description: "TSH",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών",
        id: 7
      },
      active: true,
      price: "10.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["TSH", "θυρεοειδής", "ορμόνες"]
    },
    {
      id: 1002,
      description: "FT4",
      examinationGroup: {
        name: "Εξετάσεις Βιολογικών Υλικών",
        id: 7
      },
      active: true,
      price: "10.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["FT4", "θυρεοειδής", "ορμόνες"]
    },
    {
      id: 1003,
      description: "Υπερηχογράφημα Θυρεοειδούς",
      examinationGroup: {
        name: "Απεικονιστικές Εξετάσεις",
        id: 10
      },
      active: true,
      price: "30.00",
      isHighCost: false,
      isTreatment: false,
      screening: true,
      keyWords: ["θυρεοειδής", "υπερηχογράφημα", "τράχηλος"]
    }
  ];
  
  // Common social insurance data
  const commonExaminationSocialInsurance = [
    {
      socialInsuranceId: 37,
      description: "",
      isCompensatable: true,
      isActive: true,
      infoMessage: ""
    }
  ];
  
  // =============== DIAGNOSES ===============
  // Consistent mockDiagnoses (normalized IDs)
  const mockDiagnoses = [
    {
      code: "I10",
      count: 7,
      description: "Υψηλή αρτηριακή πίεση. Υπέρταση (αρτηριακή) (καλοήθης) (ιδιοπαθής) (κακοήθης) (πρωτοπαθής) (συστηματική)",
      id: 3026,
      title: "Ιδιοπαθής (πρωτοπαθής) υπέρταση"
    },
    {
      code: "E11",
      count: 6,
      description: "Σακχαρώδης διαβήτης τύπου 2. Περιλαμβάνει: διαβήτης (σακχαρώδης) μη ινσουλινοεξαρτώμενος, έναρξη στην ενήλικο ζωή",
      id: 3027,
      title: "Σακχαρώδης διαβήτης τύπου 2"
    },
    {
      code: "R50",
      count: 1,
      description: "Πυρετός αγνώστου αιτιολογίας",
      id: 3028,
      title: "Πυρετός αγνώστου αιτιολογίας"
    },
    {
      code: "M54",
      count: 8,
      description: "Οσφυαλγία",
      id: 3029,
      title: "Οσφυαλγία"
    },
    {
      code: "K29",
      count: 5,
      description: "Γαστρίτιδα και δωδεκαδακτυλίτιδα",
      id: 3030,
      title: "Γαστρίτιδα και δωδεκαδακτυλίτιδα"
    },
    {
      code: "E78",
      count: 6,
      description: "Διαταραχές του μεταβολισμού των λιποπρωτεϊνών",
      id: 3031,
      title: "Διαταραχές του μεταβολισμού των λιποπρωτεϊνών"
    },
    {
      code: "N39",
      count: 1,
      description: "Ουρολοίμωξη",
      id: 3032,
      title: "Ουρολοίμωξη"
    },
    {
      code: "J18",
      count: 1,
      description: "Πνευμονία",
      id: 3033,
      title: "Πνευμονία"
    },
    {
      code: "B19",
      count: 1,
      description: "Ιογενής ηπατίτιδα",
      id: 3034,
      title: "Ιογενής ηπατίτιδα"
    },
    {
      code: "R51",
      count: 5,
      description: "Κεφαλαλγία. Περιλαμβάνει: προσωπαλγία, εξαιρούνται: άτυπη προσωπαλγία, ημικρανία και άλλα σύνδρομα κεφαλαλγίας",
      id: 3035,
      title: "Κεφαλαλγία"
    },
    {
      code: "E03",
      count: 5,
      description: "Υποθυρεοειδισμός",
      id: 3036,
      title: "Υποθυρεοειδισμός"
    },
    {
      code: "H40.1",
      count: 3,
      description: "Πρωτοπαθές γλαύκωμα ανοικτής γωνίας. Περιλαμβάνει: γλαύκωμα απλό χρόνιο",
      id: 3037,
      title: "Γλαύκωμα ανοικτής γωνίας"
    },
    {
      code: "N20",
      count: 1,
      description: "Νεφρολιθίαση",
      id: 3038,
      title: "Νεφρολιθίαση"
    },
    {
      code: "B35.1",
      count: 2,
      description: "Δερματοφυτία των ονύχων. Περιλαμβάνει: ονυχομυκητίαση, ονυχία δερματοφυτική",
      id: 3039,
      title: "Ονυχομυκητίαση"
    },
    {
      code: "F41.1",
      count: 4,
      description: "Διαταραχή γενικευμένου άγχους. Περιλαμβάνει: άγχος νευρωσικό, αγχώδης κατάσταση, αγχώδης αντίδραση",
      id: 3040,
      title: "Γενικευμένη αγχώδης διαταραχή"
    },
    // Add thyroid diagnosis
    {
      code: "G30",
      count: 3,
      description: "Διαταραχές Θυρεοειδούς",
      id: 3050,
      title: "Διαταραχές Θυρεοειδούς"
    },
    // Add patient-specific diagnosis
    {
      code: "PAT",
      count: 2,
      description: "Εξετάσεις Ασθενούς",
      id: 9999,
      title: "Εξετάσεις Ασθενούς"
    }
  ];
  
  // =============== REGULAR EXAMS ===============
  // Reconciled regularExams with consistent IDs
  const regularExams = [
    {
      diagnoses: [{
        Group: 1,
        code: "E11",
        count: 1,
        description: "Σακχαρώδης διαβήτης τύπου 2",
        id: 3027,
        title: "Σακχαρώδης διαβήτης τύπου 2"
      }],
      examCommentFinal: "",
      examInfo: {
        Group: "Προτεινόμενες εξετάσεις . . .",
        active: true,
        codeEdapi: 130000048,
        description: "Γλυκοζυλιωμένη Αιμοσφαιρίνη",
        doctorSortOrder: 1,
        examinationGroup: {
          active: true,
          id: 7,
          name: "Εξετασεις Βιολογικων Υλικων 1",
          notSelectable: false,
          showWideGroup: true
        },
        examinationSocialInsurances: {
          examinationSocialInsurance: commonExaminationSocialInsurance
        },
        examinationWideGroup: {
          description: "ΒΙΟΧΗΜΙΚΕΣ",
          id: 3
        },
        id: 590,
        isHighCost: false,
        isTreatment: false,
        keyWords: "HbA1c|Γλυκοζυλιωμένη",
        price: 7.00,
        screening: false
      },
      id: 590,
      numbersPrescribed: 1,
      quantity: 1,
      reason: 1
    },
    {
      diagnoses: [{
        Group: 1,
        code: "R50",
        count: 1,
        description: "Πυρετός αγνώστου αιτιολογίας",
        id: 3028,
        title: "Πυρετός αγνώστου αιτιολογίας"
      }],
      examInfo: {
        Group: "Προτεινόμενες εξετάσεις . . .",
        active: true,
        codeEdapi: 130000049,
        description: "Γενική Αίματος",
        doctorSortOrder: 2,
        examinationGroup: {
          active: true,
          id: 7,
          name: "Εξετασεις Βιολογικων Υλικων 1",
          notSelectable: false,
          showWideGroup: true
        },
        examinationSocialInsurances: {
          examinationSocialInsurance: commonExaminationSocialInsurance
        },
        examinationWideGroup: {
          description: "ΑΙΜΑΤΟΛΟΓΙΚΕΣ",
          id: 1
        },
        id: 1, // Changed from 591 to 1 for consistency
        isHighCost: false,
        isTreatment: false,
        keyWords: "CBC|γενική|αίματος",
        price: 2.88,
        screening: true
      },
      id: 1, // Changed from 591 to 1 for consistency
      numbersPrescribed: 1,
      quantity: 1,
      reason: 1
    },
    // Continue with other regularExams...
    {
      diagnoses: [{
        Group: 1,
        code: "M54",
        count: 1,
        description: "Οσφυαλγία",
        id: 3029,
        title: "Οσφυαλγία"
      }],
      examInfo: {
        Group: "Προτεινόμενες εξετάσεις . . .",
        active: true,
        codeEdapi: 130000050,
        description: "Μαγνητική Τομογραφία ΟΜΣΣ",
        doctorSortOrder: 3,
        examinationGroup: {
          active: true,
          id: 8,
          name: "Απεικονιστικές Εξετάσεις",
          notSelectable: false,
          showWideGroup: true
        },
        examinationSocialInsurances: {
          examinationSocialInsurance: commonExaminationSocialInsurance
        },
        examinationWideGroup: {
          description: "ΑΠΕΙΚΟΝΙΣΤΙΚΕΣ",
          id: 2
        },
        id: 598,
        isHighCost: true,
        isTreatment: false,
        keyWords: "DEXA|οστική πυκνότητα|οστεοπόρωση",
        price: 70.00,
        screening: true
      },
      id: 598,
      numbersPrescribed: 1,
      quantity: 1,
      reason: 1
    },
    // More regularExams...
  ];
  
  // =============== HYPERTENSION PATIENT EXAMS ===============
  // Reconciled hypertensionPatientExams with consistent IDs
  const hypertensionPatientExams = [
    {
      diagnoses: [{
        Group: 1,
        code: "I10",
        count: 1,
        description: "Υψηλη αρτηριακη πιεση",
        id: 3026,
        title: "Ιδιοπαθης (πρωτοπαθης) υπερταση"
      }],
      examCommentFinal: "",
      examInfo: {
        Group: "Προτεινόμενες εξετάσεις ασθενή . . .",
        active: true,
        codeEdapi: 130000049,
        description: "Κρεατινίνη ορού",
        doctorSortOrder: 1,
        examinationGroup: {
          active: true,
          id: 7,
          name: "Εξετασεις Βιολογικων Υλικων 1",
          notSelectable: false,
          showWideGroup: true
        },
        examinationSocialInsurances: {
          examinationSocialInsurance: commonExaminationSocialInsurance
        },
        examinationWideGroup: {
          description: "ΒΙΟΧΗΜΙΚΕΣ",
          id: 3
        },
        id: 600, // Consistent ID for Κρεατινίνη ορού
        isHighCost: false,
        isTreatment: false,
        keyWords: "Κρεατινίνη|νεφρική λειτουργία",
        price: 4.05,
        screening: false
      },
      id: 600, // Consistent ID
      numbersPrescribed: 5,
      quantity: 1,
      reason: 1
    },
    // Continue with other hypertension exams...
    {
      diagnoses: [{
        Group: 1,
        code: "I10",
        count: 1,
        description: "Υψηλη αρτηριακη πιεση",
        id: 3026,
        title: "Ιδιοπαθης (πρωτοπαθης) υπερταση"
      }],
      examCommentFinal: "",
      examInfo: {
        Group: "Προτεινόμενες εξετάσεις ασθενή . . .",
        active: true,
        codeEdapi: 130000050,
        description: "Κάλιο ορού",
        doctorSortOrder: 2,
        examinationGroup: {
          active: true,
          id: 7,
          name: "Εξετασεις Βιολογικων Υλικων 1",
          notSelectable: false,
          showWideGroup: true
        },
        examinationSocialInsurances: {
          examinationSocialInsurance: commonExaminationSocialInsurance
        },
        examinationWideGroup: {
          description: "ΒΙΟΧΗΜΙΚΕΣ",
          id: 3
        },
        id: 592,
        isHighCost: false,
        isTreatment: false,
        keyWords: "Κάλιο|ηλεκτρολύτες",
        price: 4.05,
        screening: false
      },
      id: 592,
      numbersPrescribed: 4,
      quantity: 1,
      reason: 1
    },
    // More hypertension exams...
  ];
  
 
  
 




   

    const CreateReferral = () => {

        //The selected insurance for the visit (a patient might have more than one insurances)
        const [selectedInsurance,setSelectedInsurance] = useContext(InsuranceContext)
        //The selected doctor unit
        const [selectedUnit, setSelectedUnit] = useContext(UnitContext)
        //User data
        const [data, setData] = useContext(DataContext)
        //check if user logged
        const [logged, setLogged] = useContext(LoggedContext)
        //The referal no participation cases (masterdata)
        const [examNoParticipationCases, setExamNoParticipationCases] = useContext(ExamsNonParticipationCasesContext)
        //The visit Id
        const [visitId, setVisitId] = useContext(VisitIdContext)
        //When the user selects a test opens the options
        const [grow, setGrow] = useState(true)
        //All the info about the patient
        const [patientInfo, setPatientInfo] = useContext(PatientInfoContext)
        //The refferal type ("Διαγνωση" , "Παρακολούθηση")
        const [refferalTypes, setRefferalTypes] = useContext(RefferalTypesContext)
        //The full information of the exams the user prescribed (arrray of objects)
        const [examsRegistered, setExamsRegister] = useContext(ExamsRegisteredContext)
        //The registered refferals in the visit
        const [registeredRefferals, setRegisteredRefferals] = useContext(RegisteredRefferalsContext)
        //The chosen uninsured exeption in case of an uninsured patient
        const [selectedUninsuredExeption, setSelectedUninsuredExeption] = useContext(uninsuredExeptionChosenContext)
        //Loading when the exams are inserted to the refferals (break exams)
        const [registerRefferalLoading, setRegisterRefferalLoading] = useState(false)
        //The exam packages of the user
        const [userExamPackages, setUserExamPackages] = useContext(UserExamPackagesContext)
        //Transition of the exam packages
        const [slide, setSlide] = useState(false)
        //The suggested exmas based on the prescription habits of the user
        const [examsSuggested, setExamsSuggested]=useState({
            exams:  hypertensionPatientExams.concat(regularExams),
            diagnoses : []
        })
        //The list of the HDIKA  overrides for the user to select (masterdata)
        const [overrideData, setOverrideData] = useContext(overrideContext)
        //The suggested exmas based on the prescription habits of the user
        const [discountExams, setDiscountExams]=useState([])
        //The doctor unity exam limitations
        const [unitExamLimitations, setUnitExamLimitations] = useState([])
        //Holds the seelected diagnosis of the doctor throughout the visit, the goal is to make a better UI . (Usually doctor uses only one diagnosis in all the referral)
        const preferedDiagnosis = useRef(null)
       
        //Generic snackBar to show error
        const [errorSnakActivationRefferal, setErrorSnakActivationRefferal] = useState({
            status:false,
            severity:"error",
            info:""
        })
        const rollbar = useRollbar()


      
     



     
    
        //CSS
        const useStyles = makeStyles((theme) => ({
            root: {
                height:"auto",
                margin:"auto",
                width:"auto",
                backgroundColor : "#FFFFFF",
            },
            header: {
                color: theme.palette.getContrastText(deepPurple[100]),
                backgroundColor: deepPurple[100],
              },
              headerRefferal:{
                color: theme.palette.getContrastText(deepPurple[100]),
                backgroundColor: deepPurple[100]
              },
              headerRefferalSent:{
                color: theme.palette.getContrastText(grey[50]),
                backgroundColor: grey[50]
              }
      
        }))
        const classes = useStyles();
    
    
        const ReferralForm = () => {
    
            //The user info
            const [data, setData] = useContext(DataContext)
            //Used for the conditional render of the card Content
            const [canPrecribeExams, setCanPrecribeExams] = useState(true)
            //The final value  of the selected exam 
            const [selectedExam, setSelectedExam] = useState(null)
            //The final value  of the selected exam 
            const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
            //The exam quantity (1-50)
            const [quantity, setQuantity] = useState(1)
            //The reasson of the exam ("Διάγνωση" / "Παρακολούθηση")
            const [referralReason, setReferralReason] = useState(1)
            //The comment of the exam ("Διάγνωση" / "Παρακολούθηση")
            const [examCommentFinal, setExamCommentFinal] = useState("")
            //The comment of the refferal (free text)
            const [referralCommentFinal, setReferralCommentFinal] = useContext(ReferralCommentFinalContext)
            //Proactive status
            const [proactive, setProactive] = useContext(ProactiveContext)
            //The zero case partecipation type (in case of zero case)
            const [examZeroCase, setExamZeroCase] = useContext(ExamZeroCaseContext)
            //The zero case partecipation date
            const [zeroCaseDate, setZeroCaseDate] = useContext(ZeroCaseDateContext)
            //The zero case partecipation descision number
            const [zeroCaseNumber, setZeroCaseNumber] = useContext(ZeroCaseNumberContext)
            //Activates / Deactivates the Collapse function of the ReferralForm component
            const [checked, setchecked] = useState(false)
            
            //The suggested diagnoses for the selected exam

    
            
               //Get the suggested diagnoses for the selected exam
            useEffect( ()=> {
                
                if(selectedExam && selectedExam.diagnoses){
                    setSelectedDiagnosis(selectedExam.diagnoses[0])
                }

            },[selectedExam]) 


       
            //Open the packages dialog
            const handleClickOpenDialog = () => {
                setSlide(true);
            }
            //Close the packages dialog
            const handleCloseDialog = () => {
                setSlide(false);
            }
            //Auxiliary function to add mask to the date input
            function TextMaskCustom(props) {
                const { inputRef, ...other } = props;
              
                return (
                  <MaskedInput
                  style={{height:24}}
                    {...other}
                    ref={(ref) => {
                      inputRef(ref ? ref.inputElement : null);
                    }}
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    placeholderChar={'\u2000'}
                    showMask
                  />
                );
            }  
            TextMaskCustom.propTypes = {
                inputRef: PropTypes.func.isRequired,
            }
            //functions to help user during typing .NOT to switch hbetween greek and english
            function convertGreekToEnglish(greekString) {
                const greekToEnglishMap = {
                    ';': 'q', ς: 'w',
                    α: 'a', β: 'b', γ: 'g', δ: 'd', ε: 'e', ζ: 'z', η: 'h', θ: 'u', ι: 'i', κ: 'k',
                    λ: 'l', μ: 'm', ν: 'n', ξ: 'j', ο: 'o', π: 'p', ρ: 'r', σ: 's', τ: 't', υ: 'y',
                    φ: 'f', χ: 'x', ψ: 'c', ω: 'v'
                }
            
                const englishString = greekString.toLowerCase().replace(/./g, function(match) {
                return greekToEnglishMap[match] || match;
                })
            
                return englishString
            }
            function convertEnglishToGreek(englishString) {
                const greekToEnglishMap = {
                    q: ';', w: 's', j: 'ξ',
                    a: 'α', b: 'β', g: 'γ', d: 'δ', e: 'ε', z: 'ζ', i: 'ι', h: 'η', u: 'θ', k: 'κ',
                    l: 'λ', m: 'μ', n: 'ν', o: 'ο', p: 'π', r: 'ρ', s: 'σ', t: 'τ', y: 'υ',
                    f: 'φ', x: 'χ', c: 'ψ', v: 'ω'
                }
            
                const greekString = englishString.toLowerCase().replace(/./g, function(match) {
                return greekToEnglishMap[match] || match;
                })
            
                return greekString
            }
    

               
              
        
          
   
        
            //The component for searching the medication
            const Exam = () => {
    
     
                //The full info of all the exams (masterdata, used in the autocomplete) 
                const [exams, setExams] = useState(dummyExams)
                //The input of the user when searches for an exam
                const [input, setInput] = useState(selectedExam ? selectedExam.examInfo.description : '')
                //Control the selection status (open / close) from search 
                const [openSearchResults, setOpenSearchResults] = useState(false)
                //The results of the fuzzy search sorted by probability
                const [results, setResults] = useState(examsSuggested.exams)
        

             

    
                //Dellay the search result for perfomance reasons
                const debounceHandler = useCallback(
    
                    debounce((event) => {
                        const options = {
                            isCaseSensitive: false,
                            includeScore: true,
                            shouldSort: true,
                            includeMatches: false,
                            findAllMatches: true,
                            minMatchCharLength: 0,
                            location: 0,
                            threshold: 0.2,
                            distance: 100,
                            useExtendedSearch: true,
                            ignoreLocation: true,
                            ignoreFieldNorm: true,
                           keys: [
                            {
                                name: 'description',
                                weight: 2
                            },
                            {
                                name: 'examinationGroup.name',
                                weight: 4
                            },
                            {
                                name: 'keyWords',
                                weight: 2
                            },
                           ]
                        }
                        //Make fuzzy search in most used exams
                        const fuseMostUsedExams = new Fuse(examsSuggested.exams, options)
                        //Make fuzzy search in all the exams
                        const fuseAllExams = new Fuse(exams, options)
                                                                                        //Make fuzzy search in the exams specific to the user speciality
                                                                                        //const fuseSpeciality = new Fuse(specialityExams, options)
                        //Select in what dataSet the search will be done
                        const queryAllGreek = fuseAllExams.search(convertEnglishToGreek(event))
                        //Make search in most used exams
                        const queryMostUsedGreek = fuseMostUsedExams.search(convertEnglishToGreek(event))
       
                  

                        //combine most used and all to present a complete list to the user
                        const array = [...queryMostUsedGreek,...queryAllGreek ]



                        //Find the distincts
                        const searchResult = []
                        const map = new Map();
                        for (const item of array) {
                            if(!map.has(item.item.id)){
                                map.set(item.item.id, true)
                                searchResult.push(item)
                            }
                        }

                       
    
                        //If the user has filled the input, then open the paper
                        event.length ? setOpenSearchResults(true) : setOpenSearchResults(false)
                        setResults(searchResult.map(x=>{return{examInfo:x.item}}))
                    },600),[]
                )
                //Called when the user updates the input
                const handleChange = (event) => { 
                    setOpenSearchResults(false)
                    debounceHandler(event.target.value)
                    setInput(event.target.value)
                }
                //if component loses focus closes autocomplete. Always show the selected exam in the input 
                const onBlur = () =>{
                    setOpenSearchResults(false)
                    setInput(selectedExam ? selectedExam.description :"")
                    if(results.length===0 || !selectedExam){
                        setResults(examsSuggested.exams)
                    }
                }
                //When there is no input and the user clicks the component , show the most used exams
                const onClickTextField = () =>{
                    if(input.length===0 && !registerRefferalLoading){
                        setOpenSearchResults(true)
                    }
                }
                //Clears the selected Exam and the corresponding inputs (diagnosis, dosage, ...)
                const clearSelectedExam = () => {
                    setOpenSearchResults(false)
                    setSelectedExam(null)
                    setchecked(false)
                }
                //Pick the exam selected by the user
                const selectExamFunction = (x) => {
    
                    //Scrool to the top of the page
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
    
                    setSelectedExam(x)

                    setchecked(true)
    
                }

                


    
    
            
    
                return (
                    <>
                  
                        <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        >
               
    
                            <Grid item xs={12}>
                                <form      
                                className="examsSelect"                       
                                noValidate 
                                onSubmit={(event) => event.preventDefault()}
                                autoComplete="off">
                                <Tooltip 
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography  variant='h6' color="inherit">{!selectedExam ? "Αναζήτηση φαρμάκου" : "Διαγραφή φαρμάκου"}</Typography>
                                    <Typography variant='subtitle2' color="inherit">Υπάρχουν δύο τρόποι για να καταχωρίσετε εξετάσεις: ένας μέσω της αναζήτησης εξετάσεων και ένας άλλος μέσω της υποβοήθησης διάγνωσης. Η υποβοήθηση διάγνωσης είναι χρήσιμη όταν θέλετε να καταχωρίσετε πολλές εξετάσεις ταυτόχρονα, ενώ η αναζήτηση εξετάσεων είναι πιο κατάλληλη για την καταχώριση μιας ή δύο εξετάσεων.</Typography>
                                    {selectedExam ?
                                    <Typography variant='subtitle2' color="inherit">Για να διαγράψετε την εξέταση που έχετε επιλέξει, κάντε κλικ στο εικονίδιο "Χ" που βρίσκεται στο δεξί μέρος του πεδίου.</Typography>
                                    :
                                    <Typography variant='subtitle2' color="inherit">Για να καταχωρίσετε την εξέταση χρειάζεται ο ασθενής σας, κάντε κλικ στο πεδίο "Εξετάσεις". Θα δείτε μια λίστα με τις συνιθισμένες του ασθενούς, καθώς και αυτές που χρησιμοποιείτε συχνά. Μπορείτε να επιλέξετε μια από αυτές ή να αναζητήσετε μια γράφοντας την.</Typography>
                                    }
                                </React.Fragment> : ''
                                } 
                                >
                                <TextField      
                                spellCheck="false"
                                onKeyDown={(event) => {
                                    if(event.key === "Escape" ){ setOpenSearchResults(false)}
                                }}
                                fullWidth  
                                required
                               
                                id="Εξετάσεις" 
                                onChange={handleChange} 
                                label="Εξετάσεις" 
                                variant="outlined" 
                                value={input}
                                onClick={onClickTextField}
                                onBlur={onBlur}
                                InputProps={{
                                readOnly:selectedExam ? true : false,
                                endAdornment:
                                selectedExam ?
                                    <InputAdornment position="end">
                                    <Tooltip title="Διαγραφή επιλεγμένου φαρμάκου">
                                    <IconButton
                                    disabled={selectedExam ? false : true}
                                        aria-label="Διαγραφή επιλεγμένου φαρμάκου"
                                        onClick={()=>clearSelectedExam()}
                                        edge="end"
                                    >
                                        <Cancel />
                                    </IconButton>
                                    </Tooltip>
                                    </InputAdornment> : null
                                }}
                                />
                                </Tooltip>
                                {openSearchResults && results.length ?
                                    <Paper elevation={3}  variant="outlined">
                                        <List 
                                        style={{ position: 'relative',overflow: 'auto', maxHeight:'50vh'}}
                                        dense
                                        >
                                            {results.map(x=>
                                            <Tooltip
                                            title= {!helpActivatedTooltips ?
                                                <React.Fragment>
                                                    {x.examInfo.Group === "Προτεινόμενες εξετάσεις . . ." ? 
                                                    <>
                                                    <Typography  variant='h6' color="inherit">Συχνά χρησιμοποιούμενες εξετάσεις</Typography>
                                                    <Typography variant='subtitle2' color="inherit">Όταν επιλέξετε την εξέταση, τα πεδία "Σχόλιο παραπεμπτικού", "Ποσότητα" και "Λόγος παραπομπής" θα συμπληρωθούν αυτόματα. Μπορείτε να τα αλλάξετε αν θέλετε.</Typography>
                                                    </>
                                                    :
                                                    x.examInfo.Group === "Προτεινόμενες εξετάσεις ασθενή . . ." ? 
                                                    <>
                                                    <Typography  variant='h6' color="inherit">Προτεινόμενες εξετάσεις ασθενή</Typography>
                                                    <Typography variant='subtitle2' color="inherit">Μόλις επιλέξετε την εξέταση, τα πεδία "Σχόλιο παραπεμπτικού", "Ποσότητα" και "Λόγος παραπομπής" θα συμπληρωθούν αυτόματα. Μπορείτε να αλλάξετε αυτές τις πληροφορίες, εάν είναι απαραίτητο. Το πεδίο "Διάγνωση" θα συμπληρωθεί με την τελευταία διάγνωση του ασθενούς για αυτήν την εξέταση ή εάν υπάρχει, με την διάγνωση που έχετε επιλέξει στην τελευταία εξέταση.</Typography>
                                                    </>
                                                    :
                                                    <>
                                                    <Typography  variant='h6' color="inherit">Εξέταση αναζήτησης</Typography>
                                                    <Typography variant='subtitle2' color="inherit">Όταν επιλέξετε την εξέταση, τα πεδία "Σχόλιο παραπεμπτικού", "Ποσότητα" και "Λόγος παραπομπής" θα συμπληρωθούν αυτόματα. Μπορείτε να τα αλλάξετε αν θέλετε.</Typography>
                                                    </>
                                                    }
                                                </React.Fragment>:''
                                                } 
                                            >
                                            <ListItem 
                                            dense
                                            onMouseDown={event => event.preventDefault()} 
                                            key={x.id} 
                                            button 
                                            onClick={()=>selectExamFunction(x) }>

                                                {x.examInfo.Group === "Προτεινόμενες εξετάσεις ασθενή . . ." ? 
                                                <ListItemIcon>
                                                    <Accessibility/>
                                                </ListItemIcon>
                                                :
                                                x.examInfo.Group === "Προτεινόμενες εξετάσεις . . ." ?
                                                <ListItemIcon>
                                                    <History/>
                                                </ListItemIcon>
                                                :
                                                <ListItemIcon>
                                                    <Search/>
                                                </ListItemIcon>
                                                }


                                
                                                <ListItemText 
                                                primary={x.examInfo.description} 
                                                secondary={
                                                    
                                                    <React.Fragment>
                                                        {x.examInfo.examinationGroup.name}
                                                        <br></br>
                                                        {x.examInfo.price} €
                       
                                                    </React.Fragment>
    
                                                    } />
                                                <ListItemAvatar>
                                                <Tooltip title="Γ: Γενική κατηγορία εξετάσεων, Α: Ακριβή εξέταση, Π: Προληπτική εξέταση, Θ: Θεραπεία">
                                                    <AvatarGroup max={3}>
                                                        {x.examInfo.isTreatment && <Avatar>Θ</Avatar>} 
                                                        {x.examInfo.screening && <Avatar>Π</Avatar>}  
                                                    </AvatarGroup>
                                                </Tooltip>
                                                </ListItemAvatar>
                                            </ListItem>
                                            </Tooltip>)}
                                        </List>
                                    </Paper>
                                    :
                                    openSearchResults && input.length &&
                                    <Typography color='textSecondary' variant='subtitle2' align='center'>
                                        Δεν βρέθηκε καμία εξέταση με το όνομα {input}.
                                    </Typography>
                                }
                                
    
                                </form>
                            </Grid>
    
                            {checked===false &&
                            <Grid item xs={12} >
                                <Tooltip 
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Υπάρχουν δύο τρόποι για να καταχωρίσετε εξετάσεις: ένας μέσω της αναζήτησης εξετάσεων και ένας άλλος μέσω της υποβοήθησης διάγνωσης. Η υποβοήθηση διάγνωσης είναι χρήσιμη όταν θέλετε να καταχωρίσετε πολλές εξετάσεις ταυτόχρονα, ενώ η αναζήτηση εξετάσεων είναι πιο κατάλληλη για την καταχώριση μιας ή δύο εξετάσεων.</Typography>
                                    <Typography variant='subtitle2' color="inherit">Κάντε κλικ στο εικονίδιο "Υποβοήθηση διάγνωσης" και επιλέξτε μία ή περισσότερες από τις ομάδες εξετάσεων που θέλετε να καταχωρήσετε στον ασθενή.</Typography>
                                </React.Fragment>:''
                                } 
                                >
                                <Button  className="examsPackageSelect" color="primary"  style={{ marginTop: '1rem', float: 'right'}}  variant='outlined' onClick={handleClickOpenDialog}>
                                    ΥΠΟΒΟΗΘΗΣΗ
                                </Button>
                                </Tooltip>
                            </Grid>
                            }   
    
                        </Grid>
                    </>
                
                )
            }
            //The component for searching the ICD-10
            const Diagnosis = () => {  
                
                //All the diagnoses
                const [diagnosis, setDiagnosis] = useState(mockDiagnoses)
                //The input of the user in the diagnosis
                const [input, setInput] = useState(selectedDiagnosis ? selectedDiagnosis.title : '')
                //Control the selection status (open / close) from search 
                const [openSearchResults, setOpenSearchResults] = useState(false)
                //The suggested diadnoses based on the examination selection
                const dia = useRef([])
                //The results of the fuzzy search sorted by probability
                const [results, setResults] = useState(dia.current)
               

   
             
       
    
                //If the user has selected a diagnosis in the past , suggest the same diagnosis
                useEffect( ()=> {
    
                    if(preferedDiagnosis.current){
                        setSelectedDiagnosis (preferedDiagnosis.current)
                    }
                    if(selectedExam && selectedExam.diagnoses){
                        setResults(selectedExam.diagnoses)
                    }
    
    
                },[]) 
    
                //Dellay the search result for perfomance reasons
                const debounceHandler = useCallback(
                    debounce((event) => {
                        const options = {
                            isCaseSensitive: false,
                            includeScore: true,
                            shouldSort: true,
                            includeMatches: false,
                            findAllMatches: true,
                            minMatchCharLength: 0,
                            location: 0,
                            threshold: 0.2,
                            distance: 100,
                            useExtendedSearch: true,
                            ignoreLocation: true,
                            ignoreFieldNorm: true,
                        keys: [
                            "title",
                            "code",
                            "description"
                        ]
                        }
                        //Make fuzzy search in all the diagnoses
                        const fuseDiagnosisAll = new Fuse(diagnosis, options)
                        //Make fuzzy search in the most used diagnoses for the exasm
                        const fuseDiagnosisMostUsed = new Fuse(dia.current, options)
                                                                                            //Make fuzzy search in the diagnoses specific to the speciality
                                                                                            //const fuseSpeciality = new Fuse(specialityDiagnosis, options)
                        //Select in what dataSet the search will be done
                        const queryAllGreek = fuseDiagnosisAll.search(convertEnglishToGreek(event))
                        //Make search in most used exams
                        const queryMostUsedGreek = fuseDiagnosisMostUsed.search(convertEnglishToGreek(event))
                        //Select in what dataSet the search will be done
                        const queryAllEnglish = fuseDiagnosisAll.search(convertGreekToEnglish(event))
                        //Make search in most used exams
                        const queryMostUsedEnglish = fuseDiagnosisMostUsed.search(convertGreekToEnglish(event))
                        //Make search in most used exams
                        const queryAllMix = fuseDiagnosisAll.search(event)

                        //combine most used and all to present a complete list to the user
                        const array = [...queryMostUsedEnglish,...queryMostUsedGreek,...queryAllEnglish,...queryAllGreek,...queryAllMix ]



                        //Find the distincts
                        const searchResult = []
                        const map = new Map();
                        for (const item of array) {
                            if(!map.has(item.item.id)){
                                map.set(item.item.id, true)
                                searchResult.push(item)
                            }
                        }

    
                        //If the user has filled the input, then open the paper
                        event.length ? setOpenSearchResults(true) : setOpenSearchResults(false)
                        setResults(searchResult.map(x=>x.item).slice(0, 15))
                    },600),[]
                )
                //Called when the user updates the input
                const handleChange = (event) => { 
                    setOpenSearchResults(false)
                    debounceHandler(event.target.value)
                    setInput(event.target.value)
                    if(event.target.value.length===0){
                        setSelectedDiagnosis(null)
                        preferedDiagnosis.current=null
                    }
                }
                //if component loses focus close autocomplete. Always show the selected diagnosis in the input 
                const onBlur = () =>{
                   
                    setOpenSearchResults(false)
                    setInput(selectedDiagnosis ? selectedDiagnosis.title : '')
                    //As a result set the most used diagnoses
                    setResults(dia.current)
                }
                //When the user clicks the component , show the most used diagnosis
                const onClickTextField = () =>{
                  

                    if(input.length===0 && results.length>0 ){
                        setOpenSearchResults(true)
                    }
                }
                //When the user cancels the diagnosis reset the diagnosis and input abd close results
                const clearDiagnosis = () => {
                    setSelectedDiagnosis(null) 
                    setInput('')
                    setOpenSearchResults(false)
                    preferedDiagnosis.current=null
                }
                //When the user picks a diagnosis 
                const selectDiagnosis = (x) => {
    
                    //Move to the top of the page
                    window.scrollTo({top: 0, behavior: 'smooth'})
   
    
                    setSelectedDiagnosis(x)
                }
    
          
    
                return (
    
                    <form                             
                    noValidate 
                    onSubmit={(event) => event.preventDefault()}
                    autoComplete="off">
                        <Tooltip 
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography  variant='h6' color="inherit">{!selectedDiagnosis ? "Αναζήτηση διάγνωσης" : "Διαγραφή διάγνωσης"}</Typography>
                            {selectedDiagnosis  ?
                            <Typography variant='subtitle2' color="inherit">Για να διαγράψετε τη διάδνωση που έχετε επιλέξει, κάντε κλικ στο εικονίδιο "Χ" που βρίσκεται στο δεξί μέρος του πεδίου.</Typography>
                            :
                            <Typography variant='subtitle2' color="inherit">Για να καταχωρήσετε τη διάγνωση, επιλέξτε το πεδίο διάγνωσης. Θα δείτε μια λίστα με προτεινόμενες διαγνώσεις με βάση την επιλεγμένη εξέταση, τον ασθενή και τις συχνές διαγνώσεις σας. Μπορείτε να επιλέξετε μία από αυτές ή να αναζητήσετε μια διαφορετική διάγνωση πληκτρολογώντας την στο πεδίο.</Typography>
                            }
                        </React.Fragment>:''
                        } 
                        >
                        <TextField     
                        className="diagnosisSelect"
                        spellCheck="false"
                        fullWidth  
                        required
                        error={selectedDiagnosis ? false : true}
                        id="Διαγνώσεις" 
                        onChange={handleChange} 
                        label="Διαγνώσεις" 
                        variant="outlined" 
                        value={input}
                        onClick={onClickTextField}
                        onKeyDown={(event) => {
                            if(event.key === "Escape" ){ setOpenSearchResults(false)}
                        }}
                        onBlur={onBlur}
                        InputProps={{
                            readOnly:selectedDiagnosis ? true : false,
                            endAdornment:
                            selectedDiagnosis ?
                                <InputAdornment position="end">
                                    <Tooltip title="Διαγραφή">
                                <IconButton
                                disabled={selectedDiagnosis ? false : true}
                                    aria-label="Εκκαθάριση"
                                    onClick={()=>clearDiagnosis()}
                                    edge="end"
                                >
                                    <Cancel />
                                </IconButton>
                                </Tooltip>
                                </InputAdornment> : null
                        }}
                        />
                        </Tooltip>
    
                        {openSearchResults && results.length ?
                        <Paper elevation={3} variant="outlined">
                            <List 
                            style={{ position: 'relative',overflow: 'auto', maxHeight:'50vh'}}
                            dense
                            >
                            {results.map(x=>
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    {x.Group === 0 ? 
                                    <>
                                    <Typography variant='subtitle2' color="inherit">Διάγνωση που χρησιμοποιείτε συχνά</Typography>
                                    </>
                                    :
                                    x.Group === 1 ? 
                                    <>
                                    <Typography variant='subtitle2' color="inherit">Διάγνωση που σχετίζεται με την επιλεγμένη εξέταση.</Typography>
                                    </>
                                    :
                                    <>
                                    <Typography variant='subtitle2' color="inherit">Γενιική διάγνωση από την αναζήτηση που πραγματοποιήσατε</Typography>
                                    </>
                                    }
                                </React.Fragment>:''
                                } 
                            >
                            <ListItem 
                            dense
                            onMouseDown={event => event.preventDefault()} 
                            key={x.id} 
                            button 
                            onClick={()=> selectDiagnosis(x) }>
                                {x.Group===1 ? 
                                <ListItemIcon>
                                    <FaSyringe/>
                                </ListItemIcon>
                                : x.Group===0 ? 
                                <ListItemIcon>
                                    <History/>
                                </ListItemIcon>
                                :
                                <ListItemIcon>
                                    <Search/>
                                </ListItemIcon>
                                }
                                <ListItemText primary={`${x.title} (${x.code})`}  secondary={ x.description} />
                            </ListItem>
                            </Tooltip>
                            )}
                            </List>
                        </Paper>
                        :
                        openSearchResults && input.length &&
                        <Typography color='textSecondary' variant='subtitle2' align='center'>
                        Δεν βρέθηκε καμία διάγνωση με το όνομα {input}.
                        </Typography>}
                    
                    
    
                    </form>
              
                )
            }
            //The component for defining the quantity of the exam
            const Quantity = () => {
    
                //check if the selected exam can be presribed for the patient insurance
                const [quantitySelection, setQuantitySelection] = useState([])
    
              
                const handleChange = (event) => {
                    setQuantity(event.target.value);
                }
                //Check if exam does NOT belongs to a package quantity betwen 1 and 50, if belongds to a package then 1
                useEffect( ()=> {
    
                    function checkQuantityForPackges() {
                        if(selectedExam){
                            if(discountExams.filter(x=>x.examination.id === selectedExam.id ).length > 0){
                                setQuantitySelection([1])
                            }
                            else{
                                //The value must be between 1 and 50
                                let u =[]
                                for (var i = 0; i < 50; i++) {
                                    u[i] = i+1
                                }
                                setQuantitySelection(u)
                            }
                        }
                    }
                    checkQuantityForPackges()
                },[selectedExam])
    
                
    
    
    
        
                return (
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Εισάγετε την ποσότητα εξετάσεων που θέλετε να καταχωρήσετε.</Typography>
                    </React.Fragment>
                    :''} 
                    >
                    <TextField
                    className="exameExtraInput"
                    label="Ποσότητα"
                    required
                    error={quantity ? false : true}
                    id="quantity"
                    value={quantity}
                    select
                    variant='outlined'
                    onChange={handleChange}
                    fullWidth
                    >
                        {quantitySelection.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)}
                    </TextField>
                    </Tooltip>
                )
            }
            //The component for defining the comment of the exam
            const ExamComment = () => {
        
                //Transient comment value
                const [comment, setComment] = useState(examCommentFinal)
    
                const handleChange = event => {
                    setComment(event.target.value);
                }
    
                const onBlur = ()=> {
                    setExamCommentFinal(comment)
                }
        
                return (
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εδώ μπορείτε να εισάγετε ένα προαιρετικό σχόλιο για την εξέταση.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <TextField
                        fullWidth
                        id="comment"
                        onMouseLeave={onBlur}
                        label="Σχόλια εξέτ."
                        value={comment}
                        onChange={handleChange}
                        onBlur={onBlur}
                        variant="outlined"
                        />
                        </Tooltip>
                )
            }
            //The component for defining the exam reason
            const ReferralReason = () =>{
    
                const handleChange = (event) => {
                    setReferralReason(event.target.value);
                }
    
                return(
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Επιλέξτε από την λίστα, τον λόγο παραπομπής</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <TextField
                        required
                        className="exameExtraInput"
                        label="Λόγος παραπομπής"
                        id="referral reason"
                        select
                        variant='outlined'
                        value={referralReason}
                        onChange={handleChange}
                        fullWidth
                        >
                        {[
    {
      id: 1,
      type: "Διάγνωση"
    },
    {
      id: 2,
      type: "Παρακολούθηση"
    }
  ].map(x=> <MenuItem key={x.id} value={x.id}>{x.type}</MenuItem> )}
                        </TextField>  
                        </Tooltip>     
                )
            }
            //The component for defining the comment of the whole refferal
            const RefferalComment = () => {
    
                //Transient comment value
                const [comment, setComment] = useState(referralCommentFinal)
    
                const handleChange = event => {
                    setComment(event.target.value);
                }
    
                const onBlur = ()=> {
                    setReferralCommentFinal(comment)
                }
    
                
                return (
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Εδώ μπορείτε να προσθέσετε ή να αλλάξετε τα σχόλια παραπεμπτικού.</Typography>
                    </React.Fragment>
                    :''} 
                    >
                    <TextField
                    className="exameExtraInput"
                    fullWidth
                    required
                    error={comment.length ? false : true}
                    id="comment"
                    label="Σχόλια παραπεμπτικού"
                    value={comment}
                    onBlur={onBlur}
                    onMouseLeave={onBlur}
                    onChange={handleChange}
                    variant="outlined"
                    autoComplete="off"
                    />
                    </Tooltip>
                )
            }
            //The button that registers the examination
            const SendExam = () => {
    
                //Activates / Deactivates the send button
                const [disabled, setDisabled] = useState(true)  
  
                
    
    
                //Function that registers the exam to API and front-end
                const sendExamination = () => {
                    // Create new exam object
                    const newExam = {
                        "examination": selectedExam,
                        "diagnosis": selectedDiagnosis,
                        "quantity": quantity,
                        "sent": false,
                        "referralReason": referralReason, 
                        "referralComment": referralCommentFinal,
                        "examCommentFinal": examCommentFinal
                    }

                    if(!registeredRefferals.length){
                      setDemoDialog({ 
                          status:true,
                          description:<>
                        
                          <Typography variant="subtitle2">
                          Κατά την καταχώρηση των εξετάσεων, το σύστημα τις κατανέμει αυτόματα στα αντίστοιχα παραπεμπτικά, σύμφωνα με τα χαρακτηρηστικά κάθε εξέτασης.
                          </Typography>
                        </>
                      
                      })
                    }
                    
                    // Only add if the exam doesn't already exist in the list
                    if(examsRegistered.every(x => x.examination.id !== newExam.examination.id)) {
                        // Add new exam to registered exams
                        const newExamsArray = [...examsRegistered, newExam];
                        setExamsRegister(newExamsArray);
                        
                        // Get the group type of the new exam
                        const newExamGroup = newExam.examination.examInfo.examinationGroup.name;
                        
                        // Check if there's an existing referral for this group that hasn't been sent yet
                        const existingUnsendReferralIndex = registeredRefferals.findIndex(
                            ref => !ref.sent && ref.exams.some(exam => 
                                exam.examination.examInfo.examinationGroup.name === newExamGroup
                            )
                        );
                        
                        if (existingUnsendReferralIndex !== -1) {
                            // Add to existing unsent referral
                            const updatedReferrals = [...registeredRefferals];
                            updatedReferrals[existingUnsendReferralIndex].exams.push(newExam);
                            setRegisteredRefferals(updatedReferrals);
                        } else {
                            // Create a new referral for just this exam
                            const newRefId = registeredRefferals.length > 0 
                                ? Math.max(...registeredRefferals.map(r => r.id)) + 1 
                                : 1;
                                
                            const newReferral = {
                                "id": newRefId,
                                "sent": false,
                                "err": false,
                                "response": {
                                    "sent": false,
                                    "err": 0,
                                    "info": []
                                },
                                "exams": [newExam] // Only include the newly added exam
                            };
                            
                            // Add the new referral to existing ones
                            setRegisteredRefferals([...registeredRefferals, newReferral]);
                        }
                        
                        // Clear form by resetting selected exam
                        setSelectedExam(null);
                        setchecked(false);
                    } else {
                        // Show an error message that exam already exists
                        setErrorSnakActivationRefferal({
                            status: true,
                            severity: "info",
                            info: "Η εξέταση υπάρχει ήδη στις καταχωρημένες εξετάσεις."
                        });
                    }
                }
        
          
    
    
                //Checks if the doctor has inserted all the information in the inputs
                useEffect(()=> {
                    if (selectedExam && selectedDiagnosis && quantity && referralReason && referralCommentFinal){
    
                        if(examZeroCase && examZeroCase.needsDecision && (!zeroCaseDate || !zeroCaseNumber) ){
                            setDisabled(true)
                        }
                        else{
                            setDisabled(false)
                            
                        }
                    }
                    else{
                        setDisabled(true)
                    }
                }) 
    
                
    
    
                return(
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Επιλέγοντας "ΚΑΤΑΧΩΡΗΣΗ" η εξέταση που επιλέξατε θα καταχωρηθεί σε ένα υπάρχων η νέο παραπεμπτικό . Το παραπεμπτικό στο οποίο θα καταχωρηθεί εξαρτάται από τα χαρακτηριστικά της εξέτασης καθώς και τις επιλογές που κάνατε κατά την καταχώρηση της. Αφού ολοκληρώσετε την προσθήκη όλων των εξετάσεων του ασθενή, τότε μπορείτε να καταχωρήσετε και τα παραπεμπτικά που δημιουργήθηκαν.</Typography>
                    </React.Fragment>
                    :''} 
                    >
                    <Button className="addExam" disabled={disabled} onClick={sendExamination} variant="contained" color="primary">
                        ΚΑΤΑΧΩΡΗΣΗ
                    </Button>  
                    </Tooltip>
                    
                )
            }
            const ExamGroupingDemo = () => {
              // Styles
              const useStyles = makeStyles((theme) => ({
                input: {
                  height: 61,
                },
                list: {
                  width: '100%',
                },
                dialogBackground: {
                  backgroundColor: '#eeeeee'
                },
                header: {
                  color: theme.palette.getContrastText(theme.palette.primary.light),
                  backgroundColor: theme.palette.primary.light,
                },
                slide: {
                  marginBottom: theme.spacing(2)
                },
                saveButton: {
                  marginTop: theme.spacing(2)
                }
              }));
              
              const classes = useStyles();
            
    
              
              // Mock referral types
              const refferalTypes = [
                { id: 1, type: "Διάγνωση" },
                { id: 2, type: "Παρακολούθηση" }
              ];
            
      
             // =============== MOCK PACKAGES ===============
  // Reconciled mockPackages with consistent IDs
  const mockPackages = [
    {
      packageId: "G30", // Thyroid Function
      alias: "Έλεγχος Θυρεοειδούς",
      packageInfo: [
        {
          id: 3050, // Changed to match mockDiagnoses
          code: "G30",
          title: "Διαταραχές Θυρεοειδούς",
          description: "Μυξοίδημα (υποθυρεοειδικό)"
        }
      ],
      exams: [
        {
          examUniqueName: "G30/1001",
          examinfo: {
            id: 1001,
            description: "TSH",
            examinationGroup: {
              id: 7,
              name: "Εξετάσεις Βιολογικών Υλικών"
            }
          },
          count: 1
        },
        {
          examUniqueName: "G30/1002",
          examinfo: {
            id: 1002,
            description: "FT4",
            examinationGroup: {
              id: 7,
              name: "Εξετάσεις Βιολογικών Υλικών"
            }
          },
          count: 1
        },
        {
          examUniqueName: "G30/1003",
          examinfo: {
            id: 1003,
            description: "Υπερηχογράφημα Θυρεοειδούς",
            examinationGroup: {
              id: 10,
              name: "Απεικονιστικές Εξετάσεις"
            }
          },
          count: 1
        }
      ]
    },
    // Continue with other packages...
    {
      packageId: "I10", // Hypertension package
      alias: "Έλεγχος Υπέρτασης",
      packageInfo: [
        {
          id: 3026,
          code: "I10",
          title: "Ιδιοπαθής (πρωτοπαθής) υπέρταση",
          description: "Υψηλή αρτηριακή πίεση\nΥπέρταση (αρτηριακή) (καλοήθης) (ιδιοπαθής) (κακοήθης) (πρωτοπαθής) (συστηματική)"
        }
      ],
      exams: [
        {
          examUniqueName: "I10/601",
          examinfo: {
            id: 601,
            description: "Ηλεκτρολύτες (K, Na, Ca)",
            examinationGroup: {
              id: 7,
              name: "Εξετασεις Βιολογικων Υλικων 1"
            }
          },
          count: 7
        },
        {
          examUniqueName: "I10/602",
          examinfo: {
            id: 602,
            description: "Υπερηχογράφημα καρδιάς",
            examinationGroup: {
              id: 8,
              name: "Υπερηχογραφήματα"
            }
          },
          count: 6
        },
        {
          examUniqueName: "I10/608",
          examinfo: {
            id: 608,
            description: "Holter Πίεσης 24ώρου",
            examinationGroup: {
              id: 9,
              name: "Καρδιολογικές Εξετάσεις"
            }
          },
          count: 6
        }
      ]
    },
    // Add E11 package for diabetes
    {
      packageId: "E11", // Diabetes package
      alias: "Έλεγχος Διαβήτη",
      packageInfo: [
        {
          id: 3027,
          code: "E11",
          title: "Σακχαρώδης διαβήτης τύπου 2",
          description: "Διαβήτης (σακχαρώδης) μη ινσουλινοεξαρτώμενος, έναρξη στην ενήλικο ζωή"
        }
      ],
      exams: [
        {
          examUniqueName: "E11/590",
          examinfo: {
            id: 590,
            description: "Γλυκοζυλιωμένη Αιμοσφαιρίνη",
            examinationGroup: {
              id: 7,
              name: "Εξετάσεις Βιολογικών Υλικών"
            }
          },
          count: 8
        },
        {
          examUniqueName: "E11/594",
          examinfo: {
            id: 594,
            description: "Λιπιδαιμικός Έλεγχος",
            examinationGroup: {
              id: 7,
              name: "Εξετάσεις Βιολογικών Υλικών"
            }
          },
          count: 5
        }
      ]
    },
    // Patient-specific package
    {
      packageId: "PAT", // Patient-specific package
      alias: "Συχνές Εξετάσεις Ασθενούς",
      packageInfo: [
        {
          id: 9999,
          code: "PAT",
          title: "Εξετάσεις Ασθενούς",
          description: "Ιδιοπαθης (πρωτοπαθης) υπερταση"
        }
      ],
      exams: [
        {
          examUniqueName: "PAT/591",
          examinfo: {
            id: 600,
            description: "Κρεατινίνη ορού",
            examinationGroup: {
                id: 7,
                name: "Εξετασεις Βιολογικων Υλικων 1",
            }
          },
          count: 4,
          diagnoses: [
            {
                code: "I10",
                count: 1,
                description: "Υψηλη αρτηριακη πιεση",
                id: 3026,
                title: "Ιδιοπαθης (πρωτοπαθης) υπερταση"
            }
          ]
        },
        {
          examUniqueName: "PAT/595",
          examinfo: {
            id: 592,
            description: "Κάλιο ορού",
            examinationGroup: {
                id: 7,
                name: "Εξετασεις Βιολογικων Υλικων 1",
            }
          },
          count: 3,
          diagnoses: [
            {
                code: "I10",
                count: 1,
                description: "Υψηλη αρτηριακη πιεση",
                id: 3026,
                title: "Ιδιοπαθης (πρωτοπαθης) υπερταση"
            }
          ]
        }
      ]
    }
  ];



       
            
              // Mock database for ICD codes
              const mockDiagnosisData = {
                "I10": [
                  {
                    id: 3026,
                    code: "I10",
                    title: "Ιδιοπαθής (πρωτοπαθής) υπέρταση",
                    description: "Υψηλή αρτηριακή πίεση\nΥπέρταση (αρτηριακή) (καλοήθης) (ιδιοπαθής) (κακοήθης) (πρωτοπαθής) (συστηματική)"
                  },
                  {
                    id: 3026,
                    code: "I10.1",
                    title: "Κακοήθης αρτηριακή υπέρταση",
                    description: "Υψηλή αρτηριακή πίεση με επιπλοκές"
                  }
                ],
                "E11": [
                  {
                    id: 3027,
                    code: "E11",
                    title: "Σακχαρώδης διαβήτης τύπου 2",
                    description: "Διαβήτης (σακχαρώδης) μη ινσουλινοεξαρτώμενος, έναρξη στην ενήλικο ζωή"
                  },
                  {
                    id: 3027,
                    code: "E11.9",
                    title: "Σακχαρώδης διαβήτης τύπου 2 χωρίς επιπλοκές",
                    description: "Διαβήτης τύπου 2 χωρίς επιπλοκές"
                  }
                ],
                "G30": [
                    {
                      id: 3031,
                      code: "E03.9",
                      title: "Υποθυρεοειδισμός, μη καθορισμένος",
                      description: "Μυξοίδημα (υποθυρεοειδικό)"
                    },
                    {
                      id: 3048,
                      code: "E05.0",
                      title: "Θυρεοτοξίκωση με διάχυτη βρογχοκήλη",
                      description: "Νόσος του Graves, Τοξική διάχυτη βρογχοκήλη"
                    }
                  ]
              };
            
              // Storage for selected exams
              const refContainer = useRef([]);
            
              // Initialize refContainer with the necessary structure for all exams
              useEffect(() => {
                refContainer.current = mockPackages.map(pkg => 
                  pkg.exams.map(x => {
                    return {
                      id: x.examUniqueName,
                      selected: false,
                      diagnosis: pkg.packageId === "PAT" ? x.diagnoses[0] : null,
                      referralReason: 1,
                      referralComment: "Παρακλινικός έλεγχος",
                      examZeroCase: {
                        id: '',
                        isActive: null,
                        needsDecision: null,
                        noParticipationCase: '',
                        _id: ''
                      },
                      zeroCaseDate: "",
                      zeroCaseNumber: ""
                    };
                  })
                ).flat();
              }, []);
            
   
              // TextMask component for date input
              function TextMaskCustom(props) {
                const { inputRef, ...other } = props;
                
                return (
                  <MaskedInput
                    style={{height:24}}
                    {...other}
                    ref={(ref) => {
                      inputRef(ref ? ref.inputElement : null);
                    }}
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    placeholderChar={'\u2000'}
                    showMask
                  />
                );
              }  
            
              TextMaskCustom.propTypes = {
                inputRef: PropTypes.func.isRequired,
              };
            
       
        
     
            
              // Component for a single exam package
              const SingleExamPackage = (props) => {
                const [checkedPackage, setCheckedPackage] = useState(false);
                const [diagnosisOptions, setDiagnosisOptions] = useState({loading: false, data: []});
                const [diagnosisPackage, setDiagnosisPackage] = useState(props.props.packageInfo[0]);
                const [checkedPackageSingleExam, setCheckedPackagePackageSingleExam] = useState(
                  props.props.exams.sort((a, b) => b.count - a.count).map(x => {
                    return {
                      id: x.examUniqueName,
                      diagnosis: props.props.packageId === "PAT" ? x.diagnoses[0] : null,
                      description: x.examinfo.description,
                      checked: false
                    };
                  })
                );
                const [packageRefferalsReason, setPackageRefferalsReason] = useState(1);
                const refContainerPackageComment = useRef("Παρακλινικός έλεγχος");
                const [expanded, setExpanded] = useState(false);
         
             
            
                // Function to get diagnosis data when package is expanded
                function expand() {
                  if (!diagnosisOptions.data.length) {
                    const icd = mockDiagnosisData[props.props.packageId] || [];
                    setDiagnosisOptions({loading: true, data: icd});
                    if (icd.length > 0) setDiagnosisPackage(icd[0]);
                  }
                  setExpanded(prev=>!prev)
                }
            
                // Handle checking/unchecking the entire package
                function handleChangePackage() {
                  const a = refContainer.current.filter(x => x.id.startsWith(props.props.packageId));
                  const b = refContainer.current.filter(x => !x.id.startsWith(props.props.packageId));
            
                  if (checkedPackage === true) {
                    // Unselect all exams in the package
                    const unselectAll = a.map(x => {
                      if (diagnosisPackage) {
                        return {...x, selected: false, diagnosis: diagnosisPackage};
                      } else {
                        const selectedTest = checkedPackageSingleExam.find(xx => xx.id === x.id);
                        return {...x, selected: false, diagnosis: selectedTest.diagnosis};
                      }
                    });
                    setCheckedPackagePackageSingleExam(checkedPackageSingleExam.map(x => ({...x, checked: false})));
                    setCheckedPackage(false);
                    refContainer.current = [...b, ...unselectAll];
                  } else {
                    // Select all exams in the package
                    const selectAll = a.map(x => {
                      if (diagnosisPackage) {
                        return {...x, selected: true, diagnosis: diagnosisPackage};
                      } else {
                        const selectedTest = checkedPackageSingleExam.find(xx => xx.id === x.id);
                        return {...x, selected: true, diagnosis: selectedTest.diagnosis};
                      }
                    });
                    setCheckedPackagePackageSingleExam(checkedPackageSingleExam.map(x => ({...x, checked: true})));
                    setCheckedPackage(true);
                    refContainer.current = [...b, ...selectAll];
                  }
                }
            
                // Handle individual exam selection
                const handleChangeSingleExam = (event) => {
                  const a = refContainer.current.filter(x => x.id.startsWith(event.target.name));
                  const b = refContainer.current.filter(x => !x.id.startsWith(event.target.name));
            
                  if (diagnosisPackage) {
                    a[0].selected = event.target.checked;
                    refContainer.current = [...b, {...a[0], diagnosis: diagnosisPackage}];
                  } else {
                    const selectedTest = checkedPackageSingleExam.find(xx => xx.id === a[0].id);
                    a[0].selected = event.target.checked;
                    refContainer.current = [...b, {...a[0], diagnosis: selectedTest.diagnosis}];
                  }
            
                  // Update UI state
                  setCheckedPackagePackageSingleExam(checkedPackageSingleExam.map(x => {
                    if (x.id === event.target.name) {
                      x.checked = !x.checked;
                    }
                    return x;
                  }));
            
                  // Update package checkbox state based on individual selections
                  const selectedExamCount = checkedPackageSingleExam.filter(x => x.checked === true).length;
                  if (selectedExamCount < checkedPackageSingleExam.length) {
                    if (checkedPackage === true) {
                      setCheckedPackage(false);
                    }
                  } else if (selectedExamCount === checkedPackageSingleExam.length) {
                    if (checkedPackage === false) {
                      setCheckedPackage(true);
                    }
                  }
                };
            
                // Handle diagnosis change
                function handleChangeDiagnosisPackage  (event)  {
                  const a = refContainer.current.filter(x => x.id.startsWith(props.props.packageId));
                  const b = refContainer.current.filter(x => !x.id.startsWith(props.props.packageId));
                  const changeDiagnosis = a.map(x => ({...x, diagnosis: event.target.value}));
                  refContainer.current = [...b, ...changeDiagnosis];
                  setDiagnosisPackage(event.target.value);
                };
            
                // Handle referral reason change
                const handleChangeRefferalReason = (event) => {
                  const a = refContainer.current.filter(x => x.id.startsWith(props.props.packageId));
                  const b = refContainer.current.filter(x => !x.id.startsWith(props.props.packageId));
                  const changeReferralReason = a.map(x => ({...x, referralReason: event.target.value}));
                  refContainer.current = [...b, ...changeReferralReason];
                  setPackageRefferalsReason(event.target.value);
                };
            
                // Referral comment component
                const PackageRefferalComment = () => {
                  const [comment, setComment] = useState(refContainerPackageComment.current);
            
                  const handleChange = event => {
                    setComment(event.target.value);
                  };
            
                  const onBlur = () => {
                    const a = refContainer.current.filter(x => x.id.startsWith(props.props.packageId));
                    const b = refContainer.current.filter(x => !x.id.startsWith(props.props.packageId));
                    const changeReferralComment = a.map(x => ({...x, referralComment: comment}));
                    refContainer.current = [...b, ...changeReferralComment];
                    refContainerPackageComment.current = comment;
                  };
            
                  return (
                    <Tooltip
                      title={!helpActivatedTooltips ? 
                        <React.Fragment>
                          <Typography variant='subtitle2' color="inherit">Εδώ μπορείτε να προσθέσετε ή να αλλάξετε τα σχόλια παραπεμπτικού.</Typography>
                        </React.Fragment>
                        : ''
                      }
                    >
                      <TextField
                        InputProps={{
                          className: classes.input,
                        }}
                        id="comment"
                        error={comment.length ? false : true}
                        label="Σχόλια παραπεμπτικού"
                        className="examePackageExtraInput"
                        value={comment}
                        onBlur={onBlur}
                        onMouseLeave={onBlur}
                        onChange={handleChange}
                        variant="outlined"
                        fullWidth
                        multiline
                        autoComplete="off"
                      />
                    </Tooltip>
                  );
                };
            
           
          
            
                return (
                  <>
                    
                    <Tooltip
                      title={!helpActivatedTooltips && !expanded ? 
                        <React.Fragment>
                          <Typography variant='h6' color="inherit">Ομάδα εξετάσεων</Typography>
                          <Typography variant='subtitle2' color="inherit">Αυτή είναι μια ομάδα εξετάσεων. Κάντε κλικ πάνω της για να δείτε πληροφορίες σχετικά με τις εξετάσεις που περιέχει, τη διάγνωση, τον λόγο παραπομπής και το σχόλιο παραπεμπτικού. Για να επιλέξετε όλες τις εξετάσεις σε μια ομάδα, κάντε κλικ στο τετραγωνάκι.</Typography>
                        </React.Fragment>
                        : ''
                      }
                    >
                      <Accordion TransitionProps={{ unmountOnExit: true }} expanded={ expanded} onChange={() => expand()}>
                        <AccordionSummary 
                          style={{marginBottom: props.props.packageId === "PAT" && "2rem"}}
                          className="examsGroupSelect"
                          expandIcon={<ExpandMore />}
                        >
    
                            <FormControlLabel 
                              aria-label="Επιλογή"
                              onClick={(event) => {event.stopPropagation(); handleChangePackage();}}
                              control={
                                <Checkbox
                                  checked={checkedPackage}
                                />
                              }
                              label={<Typography style={{fontWeight: 'bold'}} variant="body1">{props.props.alias}</Typography>}
                            />
                    
                        </AccordionSummary>
            
                        <AccordionDetails>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={1}
                          >
                            {props.props.packageId !== "PAT" && (
                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Tooltip
                                  title={!helpActivatedTooltips ? 
                                    <React.Fragment>
                                      <Typography variant='subtitle2' color="inherit">Για να αλλάξετε την υποκατηγορία διάγνωσης, κάντε κλικ στο πεδίο "Διάγνωση" και επιλέξτε μία από τις επιλογές της λίστας.</Typography>
                                    </React.Fragment>
                                    : ''
                                  }
                                >
                                  <TextField
                                    id="diagnosis"
                                    select
                                    className="examePackageExtraInput"
                                    autoComplete="off"
                                    style={{height:61}}
                                    label="Διάγνωση"
                                    value={diagnosisPackage}
                                    fullWidth
                                    onChange={()=>handleChangeDiagnosisPackage()}
                                    variant="outlined"
                                  >
                                    {diagnosisOptions.data.map(x =>
                                      <MenuItem key={x.id} value={x}>
                                       
                                          <Typography noWrap color="inherit">{x.title + (x.description !== "" ? ("   (" + x.description + ")") : "")}</Typography>
                                   
                                      </MenuItem>
                                    )}
                                  </TextField>
                                </Tooltip>
                              </Grid>
                            )}
                            
                            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                              <Tooltip
                                title={!helpActivatedTooltips ? 
                                  <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Για να αλλάξετε τον λόγο παραπομπής, κάντε κλικ στο πεδίο και επιλέξτε μία από τις επιλογές της λίστας.</Typography>
                                  </React.Fragment>
                                  : ''
                                }
                              >
                                <TextField
                                  id="referral reason"
                                  select
                                  fullWidth
                                  className="examePackageExtraInput"
                                  label="Λόγος Παραπομπής"
                                  value={packageRefferalsReason}
                                  onChange={handleChangeRefferalReason}
                                  variant="outlined"
                                >
                                  {refferalTypes.map(x => 
                                    <MenuItem key={x.id} value={x.id}>
                                      <Typography noWrap color="inherit">{x.type}</Typography>
                                    </MenuItem>
                                  )}
                                </TextField>
                              </Tooltip>
                            </Grid>
                            
                            <Grid item xs={12} sm={6} md={9} lg={9} xl={9}>
                              <PackageRefferalComment />
                            </Grid>
                            
                   
                            
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <Paper className="packageExamsSelection" variant="outlined">
                                <List component="div">             
                                  {checkedPackageSingleExam.map(xx =>
                                    <Tooltip
                                      key={xx.id}
                                      title={!helpActivatedTooltips ? 
                                        <React.Fragment>
                                          <Typography variant='subtitle2' color="inherit">Αυτή είναι μια εξέταση της ομάδας εξετάσεων. Μπορείτε να την εντάξετε ή να την αφαιρέσετε από την ομάδα εξετάσεων που θα καταχωρήσετε, κάνοντας κλικ στο τετράγωνο κουτάκι.</Typography>
                                        </React.Fragment>
                                        : ''
                                      }
                                    >
                                      <ListItem>
                                        <ListItemIcon>
                                          <Checkbox
                                            edge="start"
                                            onChange={handleChangeSingleExam}
                                            checked={xx.checked}
                                            name={xx.id}
                                          />
                                        </ListItemIcon>
                                        <ListItemText 
                                          primaryTypographyProps={{variant:"subtitle2"}} 
                                          primary={xx.description} 
                                          secondary={props.props.packageId === "PAT" && xx.diagnosis && xx.diagnosis.description} 
                                        />
                                      </ListItem>
                                    </Tooltip>
                                  )}
                                </List>
                              </Paper>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Tooltip>
                  </>
                );
              };
            
              // Submit handler for package selection
              const handlePackageSubmit = () => {

               // Function to map exams from ExamGroupingDemo to ExamsOfTheRefferal format
               const mapExamsToReferral = (selectedExams, mockPackages, existingReferrals = registeredRefferals) => {
                // Create a set of existing exam IDs for quick lookup
                const existingExamIds = new Set(
                    existingReferrals.flatMap(referral => 
                        referral.exams.map(exam => exam.examination.id)
                    )
                );
            
                // Filter out exams that are already inserted
                const newSelectedExams = selectedExams.filter(exam => {
                    // Find the package that contains this exam
                    const matchingPackage = mockPackages.find(pkg => 
                        pkg.exams.some(pkgExam => pkgExam.examUniqueName === exam.id)
                    );
            
                    // Find the specific exam details within the package
                    const packageExam = matchingPackage?.exams.find(
                        pkgExam => pkgExam.examUniqueName === exam.id
                    );
            
                    // Check if this exam is already in the existing referrals
                    return !existingExamIds.has(packageExam?.examinfo?.id);
                });
            
                // Map the new exams
                const mappedExams = newSelectedExams.map(exam => {
                    // Find the package that contains this exam
                    const matchingPackage = mockPackages.find(pkg => 
                        pkg.exams.some(pkgExam => pkgExam.examUniqueName === exam.id)
                    );
            
                    // Find the specific exam details within the package
                    const packageExam = matchingPackage?.exams.find(
                        pkgExam => pkgExam.examUniqueName === exam.id
                    );
            
                    return {
                        examination: {
                            id: packageExam?.examinfo?.id || null,
                            examInfo: {
                                description: packageExam?.examinfo?.description || '',
                                examinationGroup: packageExam?.examinfo?.examinationGroup || null
                            }
                        },
                        diagnosis: {
                            id: exam.diagnosis?.id || null,
                            code: exam.diagnosis?.code || '',
                            description: exam.diagnosis?.description || '',
                            title: exam.diagnosis?.title || ''
                        },
                        referralComment: exam.referralComment || 'Παρακλινικός έλεγχος',
                        referralReason: exam.referralReason || 1,
                        quantity: packageExam?.count || 1,
                        sent: false
                    };
                });
            
                // If no new exams, return existing referrals and empty mapped exams
                if (mappedExams.length === 0) {
                    return {
                        referrals: existingReferrals,
                        newExams: []
                    };
                }
            
                // Group exams by examination group
                const groupedReferrals = [...existingReferrals];
            
                mappedExams.forEach(exam => {
                    const groupName = exam.examination.examInfo.examinationGroup.name;
                    
                    // Check if a referral for this group already exists
                    const existingReferral = groupedReferrals.find(ref => 
                        !ref.sent && 
                        ref.exams[0].examination.examInfo.examinationGroup.name === groupName
                    );
            
                    if (existingReferral) {
                        // Add exam to existing referral
                        existingReferral.exams.push(exam);
                    } else {
                        // Create new referral
                        groupedReferrals.push({
                            id: Math.max(0, ...groupedReferrals.map(r => r.id)) + 1, // Ensure unique ID
                            exams: [exam],
                            response: {
                                sent: false,
                                err: null,
                                info: ''
                            },
                            sent: false
                        });
                    }
                });


                
                if(!registeredRefferals.length){
                  setDemoDialog({ 
                      status:true,
                      description:<>
                    
                      <Typography variant="subtitle2">
                      Κατά την καταχώρηση των εξετάσεων, το σύστημα τις κατανέμει αυτόματα στα αντίστοιχα παραπεμπτικά, σύμφωνα με τα χαρακτηρηστικά κάθε εξέτασης.
                      </Typography>
                    </>
                  
                  })
                }
            
                return {
                    referrals: groupedReferrals,
                    newExams: mappedExams
                };
            };
  
 
                
                const selectedExams = refContainer.current.filter(exam => exam.selected);

            
                
                const { referrals, newExams } = mapExamsToReferral(
                    selectedExams, 
                    mockPackages, 
                    registeredRefferals
                );

             

                setRegisteredRefferals(referrals);
                setExamsRegister(prev=>[...prev,...newExams])
             
             
                handleCloseDialog();
            
         
            
           
              };
            
       
            
              return (  
                <Dialog 
                open={slide}
                maxWidth='md'
                fullWidth
                onClose={handleCloseDialog}
                >
                <DialogTitle className={classes.dialogBackground}>
                    Ομάδες εξετάσεων
                </DialogTitle>
        
                <DialogContent className={classes.dialogBackground}>
                    <List className={classes.list}>
                    {mockPackages.map(x => 
                        <SingleExamPackage key={x.packageId} props={x} />
                    )}     
                    </List>
                </DialogContent>
        
                <DialogActions className={classes.dialogBackground}>
                    <Tooltip
                    title={!helpActivatedTooltips ? 
                        <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Για να επιστρέψετε στη σελίδα των εξετάσεων, επιλέξτε "Επιστροφή".</Typography>
                        </React.Fragment>
                        : ''
                    }
                    >
                    <Button variant="contained" color="secondary" onClick={handleCloseDialog}>ΕΠΙΣΤΡΟΦΗ</Button>
                    </Tooltip>
                    
                    <Tooltip
                    title={!helpActivatedTooltips ? 
                        <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Όταν ολοκληρώσετε την επιλογή των εξετάσεων που θέλετε να καταχωρήσετε, κάντε κλικ στο "Καταχώρηση" για να ενταχθούν οι εξετάσεις στα αντίστοιχα παραπεμπτικά.</Typography>
                        </React.Fragment>
                        : ''
                    }
                    >
                    <Button 
                        className="packageExamsSelection" 
                        variant="contained" 
                        color="primary" 
                        onClick={handlePackageSubmit}
                    >
                        ΚΑΤΑΧΩΡΗΣΗ
                    </Button>
                    </Tooltip>
                </DialogActions>
                </Dialog>
              );
            };
    
    
            return(
        
    
                <Grid 
                container
                direction="column"
                justifyContent="space-between"
                alignItems="stretch"
                >
                  
    
                    <Exam/>
    
    
                   
    
                    
                        <Collapse in={checked} timeout='auto'> 
                            
                            <Grid
                            style={{ marginTop: '0.5rem' }}
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            spacing={1}
                            >    
                                <Grid item xs={12}>
                                    <Diagnosis/>     
                                </Grid> 
                                <Grid item xs={12}>
                                    <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                    >    
                                        <Grid item xs={6} sm={3}  md={3} lg={3} xl={3}>
                                            <RefferalComment/>
                                        </Grid>
                                        <Grid item xs={6} sm={3}  md={3} lg={3} xl={3}>
                                            <ExamComment/>
                                        </Grid>
                                        <Grid item xs={6} sm={3}  md={3} lg={3} xl={3}>
                                            <Quantity/> 
                                        </Grid>
                                        <Grid item xs={6} sm={3}  md={3} lg={3} xl={3}>
                                            <ReferralReason/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                 
                 
         
    
                       
                 
                                <Grid item xs={12}>
                                    <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    spacing={1}
                                    >  
                                        <SendExam/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            
                        </Collapse>
    
                    
    
                    {slide && <ExamGroupingDemo/>}
                    
                     <Snackbar open={errorSnakActivationRefferal.status} onClose={()=>setErrorSnakActivationRefferal({
                            status: false,
                            severity: "",
                            info: ""
                        })}>
                     <Alert 
                     onClose={()=>setErrorSnakActivationRefferal({
                      status: false,
                      severity: "",
                      info: ""
                  })} 
                     variant='filled'
                     severity="info"
                     >
                     {errorSnakActivationRefferal.info}
                     </Alert>
                 </Snackbar>
                </Grid>
                
            )
        }
        const ExamsOfTheRefferal =()=>{
    
            const cellphoneRef = useRef("")

            //All the diagnoses
            const [diagnosis, setDiagnosis] = useContext(DiagnosisAutocompleteContext)
            //loading state of the referral
            const [loadingSend, setLoadingSend] = useState({})
            const [overRidesErr, setOverRidesErr] = useState(true)
            //Activates the dialog for inserting the patient cellphone if the referral needs preaproval 
            const [preaprooval, setPreaprooval] = useState(false) 
            const overRides = useRef({})  
            //Informs the user about the potential error
            const [errorSnac, setErrorSnac] = useState({
                status:false,
                info:''
            })
            //The abborter for the sendRefferral() call
            const abortControllerSendRefferral = useRef(null)
            //The abborter for the sendRefferralWithOverRides() call
            const abortControllerSendRefferralWithOverRides = useRef(null)
            //The abborter for the cancelReferral() call
            const abortControllerCancelReferral = useRef(null)
            //The abborter for the printReferral() call
            const abortControllerPrintReferral = useRef(null)
            //The abborter for the sendReferralSms() call
            const abortControllerSendReferralSms = useRef(null)
            //Mansory breakpoints
            const breakpointColumnsObj = {
                default: 3,
                1100: 2,
                700: 1,
                500: 1
            }
    

            const setDemoMessage = useDemoStore(state => state.setDemoMessage)
        

    
            //send the referral ONE REFERRAL
            const sendRefferral = async (x) => {
              
                const newReferals = registeredRefferals.map(xx=>{
                    if(xx.id===x.id){

                        const newExams = xx.exams.map(xxx=>{return{...xxx,sent:true}})
                       
                        return{
                            ...xx,
                            exams:newExams,
                            sent:true
                        }
                    }
                    else{
                        return xx
                    }
                })
         
                setRegisteredRefferals(newReferals)
    
            }
     
            //Delete the sent referral
            const cancelReferral= async (x)=>{

              

    
                setExamsRegister(examsRegistered.filter(exam => 
                    !x.exams.some(referralExam => referralExam.examination.id === exam.examination.id)
                ))
                setRegisteredRefferals(registeredRefferals.filter(xx=>xx.id!==x.id))

         
            }
            //Print the sent referral
            async function printReferral(x) {
    
                setDemoMessage({
                    status:true,
                    severity:"info",
                    description: "το κουμπί εκτυπώνει το παραπεμπτικό."
                })


     
            }
            //Send the sent referral to the patient via sms
            const sendReferralSms=async (x)=>{
   
                setDemoMessage({
                    status:true,
                    severity:"info",
                    description: "το κουμπί ξαναστέλνει το άυλο παραπεμπτικό."
                })
     
            }
    
            //Component that presents the prescription information of the prescribed medicine
            const Exam = (z) => {

            
    
                //expand the component ()
                const [expanded, setExpanded] = useState(false)
    
    
    
         
    
                const handleExpandClick = () => {
                    setExpanded(!expanded);
                }
    
                const deleteExam = () => {
    
                    const newExams = examsRegistered.filter(ex=>ex.examination.id!=z.props.examination.id)

                    const newReferals = registeredRefferals.map(x=>{
                        const newExams = x.exams.filter(xx=>xx.examination.id!=z.props.examination.id)
                        if(newExams.length){
                            return{
                                ...x,
                                exams:newExams
                            }
                        }
                        else{
                            return null
                        }
                    }).filter(referral => referral !== null)

                    setExamsRegister(newExams)
                    setRegisteredRefferals(newReferals)
    
                }
    
           
    
                return(
                    <div key={z.props.examination.id}  >
                    
                
                    
                    <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
    
                        <Grid item xs={10} >  
                            <ListItem button onClick={handleExpandClick}>
                            <ListItemText  primary ={'Εξέταση: '} secondary={<Typography variant='body2' style={{fontWeight:"bold"}}>{z.props.examination.examInfo.description} </Typography>}  primaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>                  
                        </Grid>
    
                        {!z.props.sent &&
                        <Grid item xs> 
                            <Grid container direction="row-reverse"  alignItems="center" spacing={1}>
                                <Tooltip title="Αφαίρεση εξέτασης από το παραπεμπτικό">
                                    <IconButton  onClick={deleteExam} >
                                         <Cancel/>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>}
    
                    </Grid>
    
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                            <Grid item xs={12}>  
                                <ListItem > 
                                <ListItemText primary ={'Διάγνωση: '} secondaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} secondary={`${z.props.diagnosis.description}` }  primaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                                </ListItem>
                            </Grid>  
                            <Grid item xs> 
                                <ListItem >
                                <ListItemText primary ={'Ποσότητα: '} secondaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} secondary={`${z.props.quantity}`}  primaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                                </ListItem>
                            </Grid>
                            <Grid item xs> 
                                <ListItem >
                                <ListItemText primary ={'Σχόλιο παραπεμπτικού: '} secondaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} secondary={`${z.props.referralComment}`}  primaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                                </ListItem>
                            </Grid>
                            {z.props.examCommentFinal &&
                            <Grid item xs> 
                                <ListItem >
                                <ListItemText primary ={'Σχόλιο εξέτασης: '} secondaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} secondary={`${z.props.examCommentFinal}`}  primaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                                </ListItem>
                            </Grid>}
                        </Grid>
                    </Collapse>          
                    <Divider light={true}/>
                </div>
                
                )
            }
   
     

            return(
                <div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                    >
                        {registeredRefferals.map(x=>
                            <div>
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography  variant='h6' color="inherit">{!x.sent ? "Παραπεμπτικό ΠΡΟΣ ΑΠΟΣΤΟΛΗ" :" ΑΠΕΣΤΑΛΜΕΝΟ παραπεμπτικό" }</Typography>
                                <Typography variant='subtitle2' color="inherit">
                                {!x.sent ?'Το παραπεμπτικό που δημιουργήσατε είναι προσωρινό, δεν έχει ακόμα καταχωρηθεί. Μπορείτε να το καταχωρήσετε επιλέγοντας το εικονίδιο "Αποστολή παραπεμπτικού" που βρίσκεται πάνω δεξιά στην επικεφαλίδα. Για να προβάλλετε τις πληροφορίες της εξέτασης όπως διάγνωση κτλ, κάντε κλικ πάνω στην εξέταση. Σε περίπτωση που θέλετε να αφαιρέσετε μια εξέταση από το παραπεμπτικό, επιλέξτε το αντίστοιχο εικονίδιο "Χ".'
                                :
                                "Το παραπεμπτικό είναι καταχωρημένο στο Σύστημα της ηλεκτρονικής συνταγογράφησης . Σε περίπτωση που θέλετε να ακυρώσετε το παραπεμπτικό επιλέξτε το εικονίδιο του 'Κάδου' , που βρίσκεται στο δεξί τμήμα της επικεφαλίδας του παραπεμπτικού. Για να το εκτυπώσετε επιλέξτε το εικονίδιο του 'Εκτυπωτή'. Τέλος για να στείλετε το άυλο παραπεμπτικό στον ασθενή επιλέξτε το εικονίδιο του 'mail'."} 
                                </Typography>
                            </React.Fragment>
                            :''} 
                            >
                                <Card className= {!x.sent &&"referalPresentationBeforeSend"}>

    
                                    <CardHeader
                                        className={x.sent && "referalPresentationAfterSend"}
                                        style={!x.sent? {color: "#fafafa",backgroundColor: "#b39ddb"} : {color: "#212121",backgroundColor: "#fafafa" }}
                                        title={
                                            <Typography style={{fontWeight:"bold"}} display='block'  variant="body1">
                                                {x.exams[0].examination.examInfo.examinationGroup.name}
                                            </Typography>
                                        }
                                       
                                        subheader={
                    
                                            (x.sent) ? 
                                            <Typography color='textSecondary' variant="subtitle2">
                                                Το άυλο παραπεμπτικό έχει αποσταλεί στον ασθενή.
                                            </Typography>
                                            :
                                            ""
                                        }
                                        action={         
                                            x.sent?
                                            <>
                                            <Tooltip title="Ακύρωση παραπεμπτικού">
                                                <IconButton onClick={()=>cancelReferral(x)} aria-label="settings">
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Εκτύπωση παραπεμπτικού">
                                                <IconButton onClick={()=>printReferral(x)} aria-label="settings">
                                                    <Print />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Αποστολή SMS παραπεμπτικού">
                                                <IconButton onClick={()=>sendReferralSms(x)} aria-label="settings">
                                                    <Email />
                                                </IconButton>
                                            </Tooltip>
                                            </>
                                            :
                                            <>
                   
                                           
                                            <Tooltip title="Αποστολή παραπεμπτικού">
                                                <IconButton onClick={ ()=> sendRefferral(x) }  aria-label="send">
                                                    <Send />
                                                </IconButton>
                                            </Tooltip>
                                            </>
                                        } 
                                    />
    
                                    
    
                                    <CardContent>
                                        {x.response.sent ?
                                        
                                        <List>
                                            {x.exams.map((z, index) => (                              
                                                <Exam key={index} props={z}/>
                                            ))}
                                        </List>
                                       
                                        :
                                        <List>
                                        {x.exams.map((z, index) => (                              
                                            <Exam key={index} props={z}/>
                                        ))}
                                        </List>   
                                        }
                                    </CardContent>
                                </Card> 
                            </Tooltip>
                            </div>
                        )}
                    </Masonry>
                    {registeredRefferals.length === 0 ? <FaNotesMedical style={{width: '100%', height: '44vh',color: '#d1c4e9'}} /> : null}
        
                </div>
            )
        }
   
    
    
    
    
        return (
            logged===true ?   
            <Grid  container direction="column" spacing={2}>
                <Grid item xs> 
                    <Card className={classes.root}>
                        <CardHeader
                            className={classes.header}
                            title={<PatientInfo/>}
                        />
    
                        <CardContent >
                            <Collapse in={grow} >
                                <ReferralForm/>
                            </Collapse>
                        </CardContent>                  
                    </Card>
                </Grid>
                <Grid item xs>              
                    <ExamsOfTheRefferal/>    
                </Grid>

            </Grid>
            : <Navigate to="/"/>
        )
    }


    return (

        logged===true ?       
        <Provider config={rollbarConfig}>
            <ErrorBoundary fallbackUI={FallbackUI}>
                <div style={{ margin:"1rem"}}> 
                <HelperPoper/>
                <DemoMessage/>
                    <Grid container spacing={3} direction="column" justifyContent="space-around"> 
                        <Grid item xs>
                            <CreateReferral/>
                        </Grid>
                        <Grid item xs>
                            <NavigationButtons/>
                        </Grid>
                    </Grid>
                </div>
                <DemoDialog/>
                <PrescriptionDashboard/>
            </ErrorBoundary>
        </Provider>
        : <Navigate to="/"/>
    );
}



